export const slugifyParameterName = (value: string): string =>
  value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'parameter';

export const getParameterIdentityKey = (name: string | undefined): string =>
  (name || '').trim().toLowerCase();

interface ManagedColumnIdentity {
  label: string;
  revitParameter?: string;
  checked: boolean;
  source: 'existing' | 'extra' | 'available';
}

export const getManagedColumnPresentation = (item: ManagedColumnIdentity) => {
  const parameterName = item.revitParameter || item.label;
  const alias = parameterName === item.label ? '' : item.label;
  const action = item.checked ? 'Hide' : item.source === 'available' ? 'Add' : 'Show';

  return {
    parameterName,
    alias,
    accessibleLabel: `${action} column ${parameterName}${alias ? ` (${alias})` : ''}`,
  };
};
